import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { joinVideoGroup } from './video-sync.js';
const PLACEHOLDER = 'linear-gradient(135deg, var(--kitup-book-peach, #f7c9ad), var(--kitup-book-lavender, #d8cef2))';
/** Видео с poster-фолбеком, картинка или нейтральная заглушка — только из переданных URL. */
export function Illustration({ src, alt = '', objectPosition = 'center', videoSrc, autoPlayVideo = true, style, }) {
    const [videoFailed, setVideoFailed] = useState(false);
    /**
     * После первого общего кадра видео остаётся видимым даже при `waiting`:
     * браузер удерживает последний декодированный кадр, пока координатор ждёт
     * обе половины. Возврат к исходной картинке на каждую дозагрузку выглядел
     * как мерцание «видео — картинка — видео».
     */
    const [videoRevealed, setVideoRevealed] = useState(false);
    const [imageFailed, setImageFailed] = useState(false);
    const videoRef = useRef(null);
    useEffect(() => {
        setVideoFailed(false);
        setVideoRevealed(false);
    }, [videoSrc]);
    useEffect(() => setImageFailed(false), [src]);
    /**
     * Один и тот же ролик может играть сразу в нескольких местах: половины
     * разворота рисуют его каждая у себя, а при повороте листа переезжают и
     * пересоздаются. Общее время держит их вместе и не даёт начать сначала.
     */
    useEffect(() => {
        const element = videoRef.current;
        if (!element || !videoSrc || videoFailed)
            return;
        return joinVideoGroup(videoSrc, element, {
            autoPlay: autoPlayVideo,
            onPlaybackChange: (playing) => {
                if (playing)
                    setVideoRevealed(true);
            },
        });
    }, [autoPlayVideo, videoFailed, videoSrc]);
    if (videoSrc && !videoFailed) {
        return (_jsxs(_Fragment, { children: [_jsx("video", { ref: videoRef, "data-illustration-video": "", src: videoSrc, "aria-label": alt, muted: true, loop: true, playsInline: true, preload: "auto", onError: () => setVideoFailed(true), style: {
                        display: 'block',
                        visibility: videoRevealed ? 'visible' : 'hidden',
                        objectFit: 'cover',
                        objectPosition,
                        ...style,
                    } }), !videoRevealed ? (src && !imageFailed ? (_jsx("img", { "data-illustration-video-poster": "", src: src, alt: "", "aria-hidden": "true", draggable: false, onError: () => setImageFailed(true), style: { display: 'block', objectFit: 'cover', objectPosition, ...style } })) : (_jsx("div", { "aria-hidden": "true", "data-illustration-placeholder": "", style: { background: PLACEHOLDER, ...style } }))) : null] }));
    }
    /**
     * Заглушка вместо битой иконки. Ссылки на приватные объекты подписаны и живут
     * час, поэтому в долгой сессии чтения картинка всё ещё может стать недоступной
     * раньше, чем страница перезапросит данные. Нейтральный фон честнее, чем
     * сломанное изображение.
     */
    if (!src || imageFailed) {
        return (_jsx("div", { "aria-hidden": "true", "data-illustration-placeholder": "", style: { background: PLACEHOLDER, ...style } }));
    }
    return (_jsx("img", { "data-illustration": "", src: src, alt: alt, draggable: false, onError: () => setImageFailed(true), style: { display: 'block', objectFit: 'cover', objectPosition, ...style } }));
}
//# sourceMappingURL=media.js.map